import { render, staticRenderFns } from "./header.vue?vue&type=template&id=5447a9be&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mobile/header.scss?vue&type=style&index=0&id=5447a9be&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447a9be",
  null
  
)

export default component.exports